import { render, staticRenderFns } from "./agencyManagement.vue?vue&type=template&id=3ba0b59e&scoped=true"
import script from "./agencyManagement.vue?vue&type=script&lang=js"
export * from "./agencyManagement.vue?vue&type=script&lang=js"
import style0 from "./agencyManagement.vue?vue&type=style&index=0&id=3ba0b59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba0b59e",
  null
  
)

export default component.exports